/**
 * `@loot-os/react/openers`: every opener kind this package ships on its own entry point, registered
 * in one call. It stays as light as the kind entries it calls: registering downloads nothing, and
 * each kind's scene (three.js, `@react-three/*`, `postprocessing`) and stylesheet load only when a
 * box first opens with it. A host that shows only some kinds registers those from their own entry
 * points instead (`@loot-os/react/neon-slam`, `/neon-pack`, `/retail-box`).
 */
import { registerNeonPack } from "./neonPack";
import { registerNeonSlam } from "./neonSlam";
import { registerRetailBox } from "./retailBox";

/** Registers Neon Slam, Neon Pack and Retail Box for every opener on the page. Idempotent. */
export function registerAllOpeners(): void {
  registerNeonSlam();
  registerNeonPack();
  registerRetailBox();
}
